import { useRef } from 'react';
import InnerHTML from 'dangerously-set-html-content';

import { useComponentAnimation } from '../VirtualArticle.hooks';

export const VirtualCustom = (props: CustomProps) => {
	const { id, bleed = false, animation, content } = props;
	const ref = useRef(null);
	const animationClasses = useComponentAnimation({
		ref,
		animation,
	});

	const classNames = [...animationClasses];
	if (bleed) {
		classNames.push('bleed');
	}

	if (!content) {
		return null;
	}

	return (
		<div id={id} ref={ref} className={classNames.join(' ')}>
			<InnerHTML html={content} />
		</div>
	);
};

interface CustomProps {
	id: string;
	bleed: boolean;
	content: string;
	animation: any;
}
